import type { Language } from '@eliadmin/core/src/api/general/types/general-types';

export const LOCALES: Language[] = [
  {
    "id": 3,
    "name": "Anglický jazyk",
    "locale": "en",
    "image": {
      "id": 3,
      "name": "gb.svg",
      "url": "https://api.migoli.eu/files/gb.svg?ai=0",
      "custom_title": "gb",
      "is_ai_generated": false
    },
    "is_default": true
  },
  {
    "id": 10,
    "name": "Nemecký jazyk",
    "locale": "de",
    "image": {
      "id": 10,
      "name": "de.svg",
      "url": "https://api.migoli.eu/files/de.svg?ai=0",
      "custom_title": "de",
      "is_ai_generated": false
    },
    "is_default": false
  }
];
